module.exports = __webpack_public_path__ + "static/media/icon-logfile.facd5e1c.svg";